import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';
import { formatDateAsQuery } from 'src/helpers/UtilityHelper';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { DefaultPageProps } from 'src/constants/Interface';
import { LinkButton } from 'src/components/atoms/button/Button';
import StyleConfig from 'src/constants/StyleConfig';
import { ShopEntity } from 'src/firebase/db/Shops';
import { AdminEntity } from 'src/firebase/db/Admins';
import SacriLogo from 'src/components/atoms/logo/SacriLogo';
import Heading from 'src/components/atoms/typo/Heading';
type Props = DefaultPageProps & {
  user: AdminEntity;
  login_shop_id: string;
  login_shop: ShopEntity;
};

class IndexPage extends Component<Props> {
  _getOwnerName = () => {
    const { login_shop } = this.props;
    return login_shop && login_shop.name ? login_shop.name : 'システム担当者';
  };

  renderNoShopConnected = (props: any) => {
    return (
      <DefaultLayout {...props}>
        <Block>
          <div className="image">
            <SacriLogo logoType={'red'} w={335} />
          </div>
          <div className="noshop">
            <h1>設定が必要です</h1>
            <p>ログインしたユーザーはお店が紐付いていません</p>
            <p>sacriの担当者の設定が必要です、担当者にお問い合わせください</p>
          </div>
          {process.env.NODE_ENV === 'development' ? (
            <aside className="dev">
              <p className="bold">Debug情報</p>
              <p>
                Role:<span>{props.user.role}</span>
              </p>
              <p>
                UID:<span>{props.user.uid}</span>
              </p>
              <p>店舗リファレンスID</p>
              <span>{JSON.stringify(props.user.shop_ids)}</span>
            </aside>
          ) : null}
        </Block>
      </DefaultLayout>
    );
  };

  render() {
    const { user, login_shop_id } = this.props;
    const ownerName = this._getOwnerName();
    if (!login_shop_id) {
      return this.renderNoShopConnected(this.props);
    }
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <div className="ballon">
            <span className="triangle">
              <ReactSVG src={'/images/icon/triangle.svg'} />
            </span>
            <span className="text">
              <span>{ownerName}</span>さんこんにちは
            </span>
          </div>
          <div className="image">
            <SacriLogo logoType={'red'} w={335} />
          </div>
          <div className="heading__container">
            <Heading tag={'h2'} text={'焼き上がり通知を行うパンの設定'} />
          </div>
          <div className="operation__list">
            <div className="list__item">
              <LinkButton
                url={'/notifications/create'}
                text={'新たにパンの焼き上がりをお知らせ'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={`/notification_templates`}
                text={`テンプレートでパンの焼き上がりをお知らせ`}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={`/shop/${login_shop_id}/search/order_breads/${formatDateAsQuery()}`}
                text={`本日の配信履歴を確認`}
                buttonColor={'white'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={`/shop/${login_shop_id}/search/orders/${formatDateAsQuery()}`}
                text={`現在の注文状況を確認`}
                buttonColor={'white'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={'/baked_breads'}
                text={'焼き上がりを通知するパンを編集'}
                buttonColor={'white'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
          </div>
          <div className="heading__container">
            <Heading tag={'h2'} text={'事前予約注文を受けるアイテムの設定'} />
          </div>
          <div className="operation__list is-reservation">
            <div className="list__item">
              <LinkButton
                url={'/reservations'}
                text={'予約注文アイテムを設定する'}
                buttonColor={'green'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={`/reservations/history`}
                text={`配信履歴を確認`}
                buttonColor={'white'}
                textColor={'green'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
            <div className="list__item">
              <LinkButton
                url={`/reservations/orders`}
                text={`現在の注文状況を確認`}
                buttonColor={'white'}
                textColor={'green'}
                textAlign={'left'}
                hasIcon={true}
                isDisabled={false}
              />
            </div>
          </div>
          <div className="heading__container">
            <Heading tag={'h2'} text={'店舗基本情報の表示設定'} />
          </div>
          <footer className="footer">
            <ul className="main">
              <li>
                <Link to={`/shop/${login_shop_id}/edit`}>基本情報を編集</Link>
              </li>
              <li>
                <Link to={`/shop/${login_shop_id}/bags/edit`}>レジ袋情報を編集</Link>
              </li>
            </ul>
            <ul className="private">
              <li>
                <Link to="/revenues">売上を確認</Link>
              </li>
              <li>
                <Link to={`/shop/${login_shop_id}/owners/mail_sender/create`}>
                  取り置き受注通知用メールアドレスの新規登録
                </Link>
              </li>
              <li>
                <Link to={`/shop/${login_shop_id}/owners/mail_sender`}>
                  取り置き受注通知用メールアドレスの確認
                </Link>
              </li>
            </ul>
          </footer>
          {process.env.NODE_ENV === 'development' ? (
            <aside className="dev">
              <p className="bold">Debug情報</p>
              <p>
                Role:<span>{user.role}</span>
              </p>
              <p>
                UID:<span>{user.uid}</span>
              </p>
              <p>店舗リファレンスID</p>
              <span>{JSON.stringify(user.shop_ids)}</span>
            </aside>
          ) : null}
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  > .ballon {
    position: relative;
    background: #fff;
    width: 80%;
    font-size: 0;
    margin: 0 auto;
    border: 2px solid ${StyleConfig.COLOR.BAR_GRAY};
    border-radius: 30px;
    margin-top: 12px;
    .triangle {
      display: block;
      width: 12px;
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      margin: auto;
      svg {
        width: 100%;
        fill: #fff;
      }
    }
    .text {
      font-size: 12px;
      padding: 12px 0;
      color: ${StyleConfig.COLOR.SECONDORY};
      text-align: center;
      display: block;
    }
  }
  > .heading__container {
    padding: 0 ${StyleConfig.HELPER.M20};
    margin: ${StyleConfig.HELPER.M16} auto;
    .attention {
      font-size: 12px;
    }
  }
  > .operation__list {
    padding: ${StyleConfig.HELPER.M12} ${StyleConfig.HELPER.M20};
    .list__item {
      margin-bottom: ${StyleConfig.HELPER.M12};
    }
  }

  > .image {
    width: 100%;
    margin: ${StyleConfig.HELPER.M24} auto;
    max-width: 268px;
  }

  > .footer {
    background: #fff;
    padding: ${StyleConfig.HELPER.M20};
    .main {
      li {
        margin-bottom: ${StyleConfig.HELPER.M20};
        font-size: 12px;
        color: ${StyleConfig.COLOR.PRIMARY};
        > a {
          color: inherit;
          text-decoration: none;
          display: inline-block;
          vertical-align: middle;
          &:after {
            content: '';
            display: inline-block;
            background-image: url(/images/icon/circle_arrow_b.png);
            background-size: cover;
            margin-left: 4px;
            width: 14px;
            height: 14px;
          }
        }
      }
    }
    .private {
      margin-bottom: ${StyleConfig.HELPER.M20};
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-color: #d2d2d2;
        margin-bottom: ${StyleConfig.HELPER.M32};
      }
      li {
        margin: ${StyleConfig.HELPER.M8} auto;
        font-size: 12px;
        > a {
          color: inherit;
          text-decoration: none;
          display: inline-block;
          vertical-align: middle;
          &:after {
            content: '';
            display: inline-block;
            background-image: url(/images/icon/circle_arrow_black.png);
            background-size: cover;
            margin-left: 4px;
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
  .noshop {
    padding: ${StyleConfig.HELPER.M20};
  }
  .dev {
    margin: ${StyleConfig.HELPER.M20} auto;
    padding: ${StyleConfig.HELPER.M20};
    .bold {
      font-weight: bold;
    }
  }
`;

const mapStateToProps = (state: any) => {
  return {
    user: state.admin.user,
    login_shop_id: state.admin.login_shop_id,
    login_shop: state.admin.user.shops.find((shop: any) => shop.id === state.admin.login_shop_id),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
